import { useTranslation } from 'react-i18next';

export const ChargePointsQrCodeHeader = (): React.JSX.Element => {
  const { t } = useTranslation();

  return <>{t('delmonicos-shared-sdk.outputs-channel.qr-code')}</>;
};
